import React, { lazy, useContext } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { PreviewHeatlhTestResultProps } from "../../../../types/components/healthTestQuestionaires.types";
import { generateProperNameFromUnderscoreValue } from "../../../../utils/commonFunctions/questionairePropertyNameConvention";
import { ThemeContext } from "../../../../contexts";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./previewHealthTestResult.css";

const customStyle = {
	modalStyle: {
		position: "absolute" as const,
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: 450,
		bgcolor: "background.paper",
		boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
		p: 4,
		borderRadius: "0.7rem"
	},
	modalContentStyle: {
		marginTop: 1,
		display: "flex",
		flexDirection: "column",
		padding: 0.5,
		overflowY: "scroll",
		maxHeight: 350
	},
	fieldLabelStyle: {
		display: "flex",
		flex: 2,
		fontWeight: 700
	},
	fieldContainerStyle: {
		padding: 1,
		display: "flex",
		gap: 2,
		"&:hover": {
			// Add hover effect
			//backgroundColor: "lightgray", // Change background color on hover
			cursor: "pointer", // Change cursor to pointer on hover
			borderColor: "blue", // Change border color to blue on hover
			borderRadius: "0.7rem"
		}
	}
};

const PreviewHeatlhTestResult: React.FC<PreviewHeatlhTestResultProps> = ({
	modalStatus,
	handleModalOperation,
	healthTestQuestionnaireFields,
	setQestionNumber
}): JSX.Element => {
	const { theme } = useContext(ThemeContext);
	const handleQuestionClickInPreview = (index: number) => {
		setQestionNumber(index);
		handleModalOperation("CLOSE");
	};
	return (
		<div className="preview-modal-main-container">
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				open={modalStatus}
				onClose={() => handleModalOperation("CLOSE")}
				closeAfterTransition
				slots={{ backdrop: Backdrop }}
				slotProps={{
					backdrop: {
						timeout: 500
					}
				}}
			>
				<Fade in={modalStatus}>
					<Box sx={customStyle.modalStyle}>
						<IconButton
							style={{ position: "absolute", top: "5px", right: "5px", color: theme.primary_color }}
							onClick={() => handleModalOperation("CLOSE")}
						>
							<CloseIcon />
						</IconButton>
						<Typography
							sx={{ color: theme.primary_color }}
							id="transition-modal-title"
							variant="h5"
							component="h2"
						>
							Response Preview
						</Typography>
						<Box sx={customStyle.modalContentStyle}>
							{Object.entries(healthTestQuestionnaireFields).map(([key, data], index) => {
								const questionLabel = key;
								const questionValue = data;
								return (
									<Box
										key={index}
										sx={customStyle.fieldContainerStyle}
										onClick={() => handleQuestionClickInPreview(index)}
									>
										<Box sx={customStyle.fieldLabelStyle}>
											{generateProperNameFromUnderscoreValue(questionLabel)}
										</Box>
										<Box
											sx={[
												{ display: "flex", flex: 1, justifyContent: "end", marginRight: "8px" },
												{ color: questionValue.length === 0 ? "red" : "black" }
											]}
										>
											{questionValue.length === 0 ? (
												<span style={{ display: "inline-block", width: "fit-content" }}>
													N/A
												</span>
											) : (
												questionValue
											)}
										</Box>
									</Box>
								);
							})}
						</Box>
					</Box>
				</Fade>
			</Modal>
		</div>
	);
};

export default PreviewHeatlhTestResult;
export const LazyPreviewHeatlhTestResult = lazy(() => import("./PreviewHeatlhTestResult"));
